export const awsCredentials = {
    accessKeyId: 'AKIATJSOSFBUXCKLCHYE',
    secretAccessKey: '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',
}
